(function () {
  const PILL_SELECTOR = '.hok-welcome-signup-pill';
  const OM_HOST_SELECTOR = 'om-download-extension';
  const STACK_GAP_PX = 10;

  function findOmWidgetRect() {
    const host = document.querySelector(OM_HOST_SELECTOR);
    if (!host) return null;

    const root = host.shadowRoot;
    if (root) {
      const widget = root.querySelector('[data-om-version].flex-col');
      if (widget) {
        const rect = widget.getBoundingClientRect();
        if (rect.width > 0 && rect.height > 0) return rect;
      }
    }

    const hostRect = host.getBoundingClientRect();
    return hostRect.width > 0 && hostRect.height > 0 ? hostRect : null;
  }

  function syncWelcomePillStack() {
    const pill = document.querySelector(PILL_SELECTOR);
    if (!pill) return;

    const omRect = findOmWidgetRect();
    const root = document.documentElement;

    if (!omRect) {
      root.style.removeProperty('--hok-floating-stack-left');
      root.style.removeProperty('--hok-floating-stack-width');
      root.style.removeProperty('--hok-welcome-pill-bottom');
      return;
    }

    root.style.setProperty('--hok-floating-stack-left', `${Math.round(omRect.left)}px`);
    root.style.setProperty('--hok-floating-stack-width', `${Math.round(omRect.width)}px`);
    root.style.setProperty(
      '--hok-welcome-pill-bottom',
      `${Math.round(window.innerHeight - omRect.top + STACK_GAP_PX)}px`,
    );
  }

  function scheduleSync() {
    window.requestAnimationFrame(syncWelcomePillStack);
  }

  scheduleSync();
  window.addEventListener('resize', scheduleSync, { passive: true });
  window.addEventListener('orientationchange', scheduleSync, { passive: true });
  window.addEventListener('hok-welcome-signup:success', scheduleSync);

  new MutationObserver(scheduleSync).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
  });
})();
